import React from "react";
import { LogoutIcon } from "./Icons";
import { useAuthContext } from "../context/auth";

function PortraitDefault({ disabledLogout }: { disabledLogout?: boolean }) {
  const { logout } = useAuthContext();
  return (
    <div className="flex flex-col justify-center items-center h-full w-full relative bg-bg">
      {!disabledLogout && (
        <button
          className="absolute top-0 right-0 m-10"
          onClick={() => logout()}
        >
          <LogoutIcon className="w-[60px] h-[60px]" />
        </button>
      )}
      <div className="flex-1 flex justify-center items-center">
        <img className="w-[680px]" src="/logo2.png" alt="logo" />
      </div>
      <div
        className="h-[64px] flex items-center justify-center w-full"
        style={{
          background:
            "var(--GMOHOB2, linear-gradient(135deg, #FFEFD6 0%, #D7B98B 100%))",
        }}
      >
        <p className="text-[#48505F] text-[32px]">Premium Training Place</p>
      </div>
    </div>
  );
}

export default PortraitDefault;
